<template>
    <velt-wireframe style="display:none;">
        <comment-thread />
        <comment-composer />
    </velt-wireframe>
</template>

<script>
import CommentThread from '@/voc/components/comments/wireframes/comment-thread.vue';
import CommentComposer from '@/voc/components/comments/wireframes/comment-composer.vue';

export default {
    name: 'ListenCommentsWireframes',
    components: {
        CommentThread,
        CommentComposer,
    },
};
</script>
